import { box, createFormGroupState, KeyValue } from 'ngrx-forms';

import { FilterFormValueInterface } from '@ideapa/app-common';

import { LazyEntityState } from './models';

export function getInitialLazyEntityState<
  Entity,
  EntityFormValue extends KeyValue
>(
  entityFormId: string,
  entityFilterFormId: string,
  initialFormValue: EntityFormValue
): LazyEntityState<Entity, EntityFormValue> {
  return {
    // set initial required properties
    entityForm: createFormGroupState<EntityFormValue>(
      entityFormId,
      initialFormValue
    ),
    entityFilterForm: createFormGroupState<FilterFormValueInterface>(
      entityFilterFormId,
      {
        filters: box([]),
      }
    ),
    selectedId: undefined,
    gridState: {
      currentPage: 0,
      pageSize: 30,
      totalRows: 0,
      pageLoaded: false,
      filterModel: {},
    },
    loadedEntity: undefined,
    showAdvancedFilters: false,
  };
}

export function createInitialStateFactory<
  Entity,
  EntityFormValue extends KeyValue
>(
  entityFormId: string,
  entityFilterFormId: string,
  initialFormValue: EntityFormValue
) {
  function getInitialState(): LazyEntityState<Entity, EntityFormValue>;
  function getInitialState<S extends object>(
    additionalState: S
  ): LazyEntityState<Entity, EntityFormValue> & S;
  function getInitialState(additionalState: any = {}): any {
    return Object.assign(
      getInitialLazyEntityState(
        entityFormId,
        entityFilterFormId,
        initialFormValue
      ),
      additionalState
    );
  }

  return { getInitialState };
}
